// import ProductDisplay from './product/ProductDisplay.vue'
import Sidecart from './sidecart/Sidecart.vue'
import ProductDisplay from './product/ProductDisplay.vue'
import ProductForm from './product/ProductForm.vue'
import PrimaryButton from './buttons/PrimaryButton.vue'
import SubmitButton from './buttons/SubmitButton.vue'
import Icon from './basic/Icon.vue'
import ColorSwatches from './basic/ColorSwatches.vue' 

export default {
    Sidecart,
    ProductDisplay,
    ProductForm,
    PrimaryButton,
    SubmitButton,
    Icon,
    ColorSwatches
}